export const marketing_growth = [
  { char: '📈', name: 'Chart Up', nameZh: '流量成長', keywords: ['growth', 'traffic', 'seo'], hot: true },
  { char: '🎯', name: 'Target', nameZh: '精準客群', keywords: ['audience', 'goal', 'ads'], hot: true },
  { char: '📣', name: 'Megaphone', nameZh: '口碑行銷', keywords: ['pr', 'marketing', 'shout'] },
  { char: '🌪️', name: 'Tornado', nameZh: '行銷漏斗', keywords: ['funnel', 'convert', 'user'] },
  { char: '💰', name: 'Money', nameZh: '投資報酬率', keywords: ['roi', 'profit', 'ad spend'] },
  { char: '📊', name: 'Bar Chart', nameZh: '數據分析', keywords: ['data', 'report', 'analytics'] },
  { char: '💡', name: 'Idea', nameZh: '創意提案', keywords: ['creative', 'idea', 'pitch'] },
  { char: '💌', name: 'Love Letter', nameZh: '電子報行銷', keywords: ['edm', 'email', 'newsletter'] },
  { char: '🔍', name: 'Search', nameZh: 'SEO關鍵字', keywords: ['keyword', 'search', 'rank'] },
  { char: '🌟', name: 'Star', nameZh: '品牌價值', keywords: ['brand', 'value', 'top'] },
  { char: '🤝', name: 'Deal', nameZh: '商務談判', keywords: ['b2b', 'partner', 'agree'] },
  { char: '🤳', name: 'Selfie', nameZh: '網紅行銷', keywords: ['koc', 'kol', 'social'] },
];